import * as React from 'react';
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip } from '@mui/material';
import { connect } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';
import { centered_flex_box } from '../../app/components/Styles';
import { t } from 'i18next';
import { Image } from 'antd';
import { isMobile } from 'react-device-detect';
import Logo from "../../app/components/logo.png"
import ImageComponent from '../../app/components/ImageComponent';

export const ComingSoon = ({ }) => {

    return (
        <Container>
            <Box sx={{ ...centered_flex_box, flexDirection: "column" }}>
                <Box sx={{ ...centered_flex_box, paddingTop: 10, flexDirection: "column" }}>
                    <ImageComponent width={227} preview={false} src={Logo} />
                </Box>
                <ConstructionIcon sx={{ fontSize: "300px" }} />
                <Typography textAlign="center" fontSize={40}>Page Under Construction</Typography>
            </Box>
        </Container>
    );
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ComingSoon);